import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "vant/lib/index.css";
import "@/assets/global.scss";
import "@/assets/font/iconfont.css";

import { initVantComponents, initDataRanger } from "./install-plugins";

Vue.config.productionTip = false;

initVantComponents();
initDataRanger();

Vue.mixin({
  computed: {
    isUserLogin() {
      const user = this.$store.state.user;
      return !!(user && user.user_id);
    }
  },
  methods: {
    navigateWithAuth(fn, noAuthFn) {
      if (this.isUserLogin) {
        return fn();
      } else {
        noAuthFn && noAuthFn();
        this.$notify({ type: "warning", message: "Please Login", background: "#996EFF", duration: 1500 });
        this.$router.push({ name: "login" });
      }
    }
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
